import { z } from 'zod';
import { emailValidator, passwordValidator, usernameValidator } from '../../utils/common';
export const LoginUserSchema = z
    .object({ email: usernameValidator, password: passwordValidator })
    .describe('Login User object with username and password');
export const LoginUserEmailSchema = z
    .object({ email: emailValidator, password: passwordValidator })
    .describe('Login User object with email and password');
//# sourceMappingURL=loginUserSchema.js.map